import React from 'react';

import DataProtectionPage from './DataProtectionPage';

export const TalentManager = () => {
  return <DataProtectionPage id="dp_xtm_inc.txt" />;
};

export const TalentPoolManager = () => {
  return <DataProtectionPage id="dp_xtp_inc.txt" />;
};

export const FreelancerManager = () => {
  return <DataProtectionPage id="dp_freelancer_manager_inc.txt" />;
};
